import { useStore } from 'effector-react';
import { useLocalization } from 'model/localization.model';
import { template$ } from 'model/session.model';
import { h } from 'preact';
import { css } from 'linaria';
import { useState } from 'preact/hooks';

import { Tabs, TabItem } from 'features/fallback/ui/tabs';
import { FallbackLayout } from 'features/fallback/ui/fallback-layout';
import { LinkQrCodeView } from 'features/fallback/features/link/link-qr-code';
import { LinkCopyView } from 'features/fallback/features/link/link-copy';
import { LinkEmailView } from 'features/fallback/features/link/link-email';
import { LinkSmsView } from 'features/fallback/features/link/link-sms';

enum LinkType {
	qr = 'qr',
	link = 'link',
	email = 'email',
	sms = 'sms',
}

export const LinkView = () => {
	const t = useLocalization();
	const template = useStore(template$);

	const tabs: TabItem[] = [{
		title: t('flow.tabs.qr'),
		key: LinkType.qr,
	}, {
		title: t('flow.tabs.link'),
		key: LinkType.link,
	}, {
		title: t('flow.tabs.email'),
		key: LinkType.email,
	}, {
		title: t('flow.tabs.sms'),
		key: LinkType.sms,
	}].filter(item => template.handoff_variants.includes(item.key));

	const [currentTab, changeCurrentTab] = useState(tabs[0].key);

	return (
		<FallbackLayout>
			<Tabs
				items={tabs}
				active={currentTab}
				className={tabsClass}
				onChange={key => changeCurrentTab(key as LinkType)}
			/>
			{currentTab === LinkType.qr && (
				<LinkQrCodeView/>
			)}
			{currentTab === LinkType.link && (
				<LinkCopyView/>
			)}
			{currentTab === LinkType.email && (
				<LinkEmailView/>
			)}
			{currentTab === LinkType.sms && (
				<LinkSmsView/>
			)}
		</FallbackLayout>
	);
};

const tabsClass = css`
  margin-top: 18px;
  margin-bottom: 24px;
`;
